import { SubProducts as EngineSubProducts } from "@imi-ernd-be/hyselect-engine";
import { buildProductEntries } from "./buildProductEntries";
import { SubProducts } from "./types";

export function buildSubProducts(
  subProducts: EngineSubProducts | null,
): SubProducts {
  return {
    accessories: buildProductEntries(subProducts?.accessories),
    actuators: buildProductEntries(subProducts?.actuators),
    adapters: buildProductEntries(subProducts?.adapters),
    bufferVessels: buildProductEntries(subProducts?.bufferVessels),
    measuringValves: buildProductEntries(subProducts?.measuringValves),
    sensors: buildProductEntries(subProducts?.sensors),
    spareParts: buildProductEntries(subProducts?.spareParts),
  };
}
